import {IFilterFunction} from "angular";
import {PricingInstruction, pricingInstructionName} from "../models/PricingInstruction";

export const PricingInstructionId = "tfPricingInstruction";

export function pricingInstruction(): IFilterFunction {
    return (value: PricingInstruction | null) => {
        if (value == null) {
            return null;
        }
        return pricingInstructionName(value);
    };
}
